// components/PrivateRoute.tsx
import { LoadState, UserRoles } from '@diditusa/shared/types/commonTypes';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ManagerRoute: React.FC = () => {
  const { isAuthenticated, loadState, userRole } = useAuth();

  if (loadState === LoadState.LOADING) return <div>Loading...</div>;

  return isAuthenticated && userRole === UserRoles.MANAGER ? (
    <Outlet />
  ) : (
    <Navigate to='/home' replace />
  );
};

export default ManagerRoute;
